var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Login"}},[_c('div',{staticClass:"handle"},[_c(_vm.componentName,{tag:"component",on:{"toogle":_vm.toogle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }